import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as toastrReducer } from 'react-redux-toastr';
import video from './video/video.reducer';
import options from './options/options.reducer';
import checks from './checks/checks.reducer';
import notification from './notification/notification.reducer';
import api from './api/api.reducer';
import dynamic from './dynamic/dynamic.reducer';
import playback from './playback/playback.reducer';

const rootReducer = (history: Object) =>
    combineReducers({
        video,
        options,
        checks,
        notification,
        api,
        dynamic,
        playback,
        toastr: toastrReducer,
        router: connectRouter(history),
    });

export default rootReducer;
